import { atom } from 'recoil';

let baseContents = atom<any>({
  key: 'baseContents',
  default: {
    approvedHistoryList: [],
    compCount: '',
    compDetail: {},
    mainItemList: [],
    supportText: '',
    serverTime: '',
  },
});

export { baseContents };
